import _ from 'lodash'
import React from 'react'
import axios from 'axios'
import moment from 'moment'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { sendRequest } from '../../modules/admin'
import { fetchBookingDates2 } from '../../modules/bookings'
import { fetchUseractions, createAction } from '../../modules/useractions'
import {
  updateBooking,
  changeFinished as changeFinished2,
  editFinished
} from '../../modules/bookedit'
import {
  changeFinished,
  fetchAll,
  newUserRequired,
  newUserNotRequired,
  updateUser
} from '../../modules/users'
import './class.scss'
import Alert from '../views/alert'
import Payment from '../views/payment'
import config from '../../variables/config'
import IosArrowRoundBack from 'react-ionicons/lib/IosArrowRoundBack'
import IosCloseCircleOutline from 'react-ionicons/lib/IosCloseCircleOutline'
import { isBlank } from '../helpers/validation'
import DatePicker from 'react-date-picker'
import { AiFillCodeSandboxCircle } from 'react-icons/ai'

const firstNameText = 'First name'
const lastNameText = 'Last name'
const tryAgainText = 'Please try again later'
const classText = 'Buy Play Only'
const classText2 = 'Change Play Only'
const searchText = 'Search by name or surname or email'
const pleaseSelectUText = 'Please select a user'
const addUserText = 'Add new user'
const changeText = 'Change'
const deleteText = 'Delete'
const pleaseSelectGText = "Guests' details"
const relationText = 'Family relation'
const dayText = 'Day'
const monthText = 'Month'
const yearText = 'Year'
const datesText = 'Date'
const submitText = 'Submit'
const payText = 'Pay and Submit'
const pleaseSelectText = 'Please select a user'
const errorMessage1Text = 'Something went wrong, please try again later'
const infoMissingText = 'Some guest info is missing'
const totalText = 'Total'
const noteText = 'Note'
const discountedTotalText = 'Discounted Total'
const discountCodeText = 'Discount code'
const applyText = 'Apply'
const invalidCodeText = 'Invalid Discount Code'
const clockinText = 'Clock in'
const clockoutText = 'Clock out'
const clockinAtText = 'Latest clock in'
const clockoutAtText = 'Latest clock out'

const guestGroupsText = {
  guestGroup1Text: 'Under 12 months',
  guestGroup2Text: '1 - 2 Years',
  guestGroup3Text: '2 - 3 Years',
  guestGroup4Text: '4 & Over',
  guestGroup5Text: 'Adults',
  guestGroup6Text: 'Play & Eat, 1 - 2 Years',
  guestGroup7Text: 'Play & Eat, 3 & Over',
  guestGroup8Text: 'Special Offer'
}

const groupRates = [0, 0, 3.95, 5.95, 6.95, 1.5, 7.5, 7.5]
const rates1 = [0, 425, 675, 775, 200, 0, 0]
const rates2 = [0, 395, 595, 695, 150, 750, 1050]

var timeSlots = [
  '9:00am - 11:30am',
  '11:30am - 14:00pm',
  '14:00pm - 16:30pm',
  '16:30pm - 18:00pm'
]

const emptyAlert = {
  showAlert: false,
  message: '',
  type: '',
  callback: () => {}
}

class Class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      search: '',
      lastName: '',
      firstName: '',
      searchedUsers: [],
      selectedUser: {
        selected: false,
        user: {}
      },
      image: '',
      alert: _.clone(emptyAlert),
      tickets: [],
      passDate: new Date(),
      selectedTime: '',
      showPayment: false,
      paymentDone: false,
      note: '',
      discount: {
        discountInput: '',
        discountApplied: false,
        discountInstance: {}
      },
      paymentMethod: {},
      originalGroups: []
    }
  }

  componentDidMount = async () => {
    if (this.props.classEditOn) {
      this.setState({
        tickets: this.props.classObj.tickets,
        originalGroups: {},
        passDate: new Date(this.props.classObj.classDate),
        selectedTime: this.props.classObj.classTime,
        note: this.props.classObj.note
      })
    }

    if (
      this.props.userForBooking.required &&
      this.props.userForBooking.user.id
    ) {
      this.setState({
        selectedUser: {
          selected: true,
          user: this.props.userForBooking.user
        }
      })

      this.props.newUserNotRequired()
    }

    if (this.props.classObj.member) {
      const membershipId = this.props.classObj.member
        ? this.props.classObj.member
        : ''

      const token = JSON.parse(window.localStorage.getItem('userData')).token
      let user = {}
      let image = ''

      try {
        const membership = (await axios.get(
          config.serverURL +
            '/Memberships/' +
            membershipId +
            '?access_token=' +
            token
        )).data
        if (membership.userId) {
          user = (await axios.get(
            config.serverURL +
              '/OnsiteUsers/' +
              membership.userId +
              '?filter={"include":["guardians"]}&access_token=' +
              token
          )).data
          if (!user) {
            user = (await axios.get(
              config.serverURL +
                '/WKUsers/' +
                membership.userId +
                '?filter={"include":["guardians"]}&access_token=' +
                token
            )).data
          }
          image = user.image ? user.image : ''
        }
      } catch (err) {
        console.log(err, 'membership error')
      }

      const imageFinal =
        'https://api.wackykingdom.com/api/ImageUploads/wackykingdom/download/' +
        image +
        '?access_token=' +
        token
      this.setState({
        selectedUser: {
          selected: true,
          user: this.props.userForBooking.user
        },
        image: imageFinal
      })
    }
    this.props.sendRequest(fetchAll)
    this.props.sendRequest(fetchUseractions)
    this.props.sendRequest(fetchBookingDates2)
  }

  getMonthFromString = mon => {
    var d = Date.parse(mon + '1, 2012')
    if (!isNaN(d)) {
      return new Date(d).getMonth() + 1
    }
    return -1
  }

  handleChange = (property, { target }) => {
    this.setState({
      [property]: target.value
    })
  }

  animateClose = () => {
    if (this.props.classEditOn) {
      this.props.editFinished()
    }
    // this.setState({
    //   shouldClose: true
    // }, () => {
    //   setTimeout(() => {
    this.props.closeWindow()
    //   }, 500)
    // })
  }

  checkForAlert = () => {
    if (this.state.alert.showAlert) {
      return <Alert alert={this.state.alert} />
    } else if (this.props.requestFailed || this.props.requestFailed2) {
      var alert = _.clone(emptyAlert)
      alert.type = 'error'
      alert.showAlert = true
      alert.message = tryAgainText
      alert.callback = () => {
        if (this.props.requestFailed2) this.props.changeFinished2()
        else this.props.changeFinished()
      }

      return <Alert alert={alert} />
    } else if (this.props.requestFinished || this.props.requestFinished2) {
      var alert2 = _.clone(emptyAlert)
      alert2.type = 'success'
      alert2.showAlert = true
      alert2.callback = () => {
        if (this.props.requestFinished2) {
          this.props.changeFinished2()
          this.animateCloseOpen('checkbook')
        } else {
          this.props.closeWindow()
          this.props.changeFinished()
        }
      }

      return <Alert alert={alert2} />
    } else {
      return void 0
    }
  }

  animateCloseOpen = redirect => {
    if (redirect === 'register') this.props.newUserRequired('class')
    // this.setState({
    //   shouldClose: true
    // }, () => {
    //   setTimeout(() => {
    this.props.closeOpenWindow(redirect)
    //   }, 500)
    // })
  }

  selectUser = user => {
    this.setState({
      selectedUser: {
        user: user,
        selected: true
      }
    })
  }

  unselectUser = () => {
    this.setState({
      selectedUser: {
        user: {},
        selected: false
      }
    })
  }

  handleAmountChange = (property, e) => {
    var amount = e.target.value
    if (isNaN(amount) || amount === '') amount = 0
    else amount = Number(amount)

    var currentGroup = this.state[property]

    if (currentGroup.length < amount) {
      var prevLength = currentGroup.length
      for (var i = 0; i < amount - prevLength; i++) {
        currentGroup.push({
          firstName: '',
          lastName: '',
          birthday: {
            day: 1,
            month: 1,
            year: 2000
          },
          relation: '',
          opened: true
        })
      }
    } else if (currentGroup.length > amount) {
      var prevLength2 = currentGroup.length
      for (var k = 0; k < prevLength2 - amount; k++) {
        currentGroup.pop()
      }
    }

    this.setState({
      [property]: currentGroup
    })
  }

  handleGuestChange = (property, groupIndex, itemIndex, e) => {
    var tickets = this.state['tickets']
    tickets[itemIndex][property] = e.target.value

    this.setState({
      ['tickets']: tickets
    })
  }

  handleBirthdayChange = (property, groupIndex, itemIndex, e) => {
    var guestGroup = this.state['guestGroup' + groupIndex]
    guestGroup[itemIndex]['birthday'][property] = e.target.value

    this.setState({
      ['guestGroup' + groupIndex]: guestGroup
    })
  }

  toogleOpened = (groupIndex, itemIndex) => {
    var guestGroup = this.state['guestGroup' + groupIndex]
    guestGroup[itemIndex].opened = !guestGroup[itemIndex].opened

    this.setState({
      ['guestGroup' + groupIndex]: guestGroup
    })
  }

  search = () => {
    var items = _.clone(this.props.users)

    var search = this.state.search
    var filteredItems = items.filter(item => {
      if (item.firstName.substring(0, search.length).toLowerCase() === search)
        return true
      else if (
        item.lastName.substring(0, search.length).toLowerCase() === search
      )
        return true
      else if (item.email.substring(0, search.length).toLowerCase() === search)
        return true
      else return false
    })

    return filteredItems
  }

  handleDateChange = date => {
    const timeslots = this.getSlots(date)

    this.setState({
      passDate: date,
      selectedTime: timeslots.length > 0 ? timeslots[0] : ''
    })
  }

  timeChange = time => {
    this.setState({
      selectedTime: time.target.value
    })
  }

  showAlert = (message, type) => {
    var alert = {
      showAlert: true,
      message: message,
      type: type,
      callback: () => {
        this.setState({ alert: _.clone(emptyAlert) })
      }
    }
    this.setState({ alert })
  }

  getMonth = index => {
    var months = [
      '',
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ]

    return months[index]
  }

  change = async () => {
    var data = {
      type: 'ClassBookings',
      id: this.props.classObj.id,
      properties: {
        price: this.getTotal(),
        note: this.state.note,
        oldNote: this.props.classObj.note,
        oldDate: this.props.classObj.date + ' ' + this.props.classObj.time,
        classDate: new Date(this.state.passDate).setHours(10),
        classTime: this.state.selectedTime,
        oldVisitorDetails: this.state.originalGroups,
        tickets: this.state.tickets
      }
    }

    this.props.sendRequest(updateBooking, data)
  }

  delete = async () => {
    if (
      window.confirm(
        'Are you sure you want to delete this booking? The action is permanant deletion and data is irrecoverable. Press CANCEL if unsure.'
      )
    ) {
      if (
        window.confirm(
          'Press OK to delete this booking. Please make sure your manager is informed. Any deletion without manager approval will be seriously breaching the portal user rule'
        )
      ) {
        let token = JSON.parse(window.localStorage.getItem('userData')).token
        let response = []
        try {
          response = await axios.delete(
            config.serverURL +
              '/ClassBooking' +
              config.endpoint +
              '/' +
              this.props.classObj.id +
              '?access_token=' +
              token
          )
          window.alert('Booking Deleted')
        } catch (err) {
          if (response.data.status === 'success') {
            console.log('response ok')
          } else {
            throw new Error(response.data.error)
          }
        }
      }
    }
  }

  formatDate = date => {
    const monthsArray = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ]
    const day = date.getDate()
    const month = monthsArray[date.getMonth()]
    const year = date.getFullYear()

    var suffix

    switch (day) {
      case 1:
      case 21:
      case 31:
        suffix = 'st'
        break
      case 2:
      case 22:
        suffix = 'nd'
        break
      case 3:
      case 23:
        suffix = 'rd'
        break
      default:
        suffix = 'th'
    }

    return day + suffix + ' ' + month + ', ' + year
  }

  submit = async paymentMethod => {
    var errorMessage = errorMessage1Text

    if (!this.state.selectedUser.user.id) {
      this.showAlert(pleaseSelectText, 'warning')
      return
    }

    if (paymentMethod) {
      this.setState({
        paymentDone: true
      })
    }

    if (!paymentMethod && this.state.paymentMethod.id)
      paymentMethod = this.state.paymentMethod

    try {
      var classBooking = {
        orderDate: new Date(),
        total: this.getTotal() * 100,
        classDate: this.state.passDate,
        note: this.state.note,
        discountedTotal: this.getPayAmount() * 100,
        discountCodeUsed: this.state.discountCode,
        classTime: !this.state.selectedTime
          ? this.getSlots(this.state.passDate)[0]
          : this.state.selectedTime,
        tickets: this.state.tickets,
        reference: this.generateReferenceNumber('WKCB'),
        paymentMethod: paymentMethod ? paymentMethod : {},
        onsiteUserId: this.state.selectedUser.user.id,
        wKUserId: this.state.selectedUser.user.id
      }
      let token = JSON.parse(window.localStorage.getItem('userData')).token

      const response = await axios.post(
        config.serverURL +
          '/ClassBooking' +
          config.endpoint +
          '?access_token=' +
          token,
        classBooking
      )

      const quantities = {}
      this.state.tickets.map(t => (quantities[t.name] = t.quantity))

      const emailDetails = {
        email: this.state.selectedUser.user.email,
        bookingRefNo: response.data.reference,
        paymentDate: this.formatDate(new Date()),
        name:
          this.state.selectedUser.user.firstName +
          ' ' +
          this.state.selectedUser.user.lastName,
        ticketDate: this.formatDate(new Date(response.data.date)),
        ticketTime: response.data.time,
        ticketPrice: '£' + this.getTotal(),
        quantities: quantities
      }

      const emailToAdmin = {
        email: 'admin@wackykingdom.com',
        bookingRefNo:
          'Portal Booking ' + response.data.reference + ' ' + response.data.id,
        paymentDate: this.formatDate(new Date()),
        name:
          this.state.selectedUser.user.firstName +
          ' ' +
          this.state.selectedUser.user.lastName,
        ticketDate: this.formatDate(new Date(response.data.date)),
        ticketTime: response.data.time,
        ticketPrice: '£' + this.getTotal(),
        quantities: quantities
      }

      await axios.post(
        config.serverURL + '/sendOrderConfirmation',
        emailDetails
      )
      await axios.post(
        config.serverURL + '/sendOrderConfirmation',
        emailToAdmin
      )

      if (response.data.id) {
        var alert = {
          showAlert: true,
          type: 'success',
          callback: () => {
            this.setState({ alert: _.clone(emptyAlert) })
            this.animateClose()
          }
        }
        this.setState({ alert })

        return
      }
    } catch (error) {
      errorMessage = error.message
      console.log('class - submit:', error.message)
    }
    var alert2 = {
      showAlert: true,
      message: errorMessage,
      type: 'error',
      callback: () => {
        this.setState({ alert: _.clone(emptyAlert) })
      }
    }
    this.setState({ alert: alert2 })
  }

  generateReferenceNumber = prefix => {
    var today = new Date()
    const year = today.getFullYear()
    var month = today.getMonth() + 1
    if (month < 10) month = '0' + month
    var day = today.getDate()
    if (day < 10) day = '0' + day
    const randomNo = Math.floor(Math.random() * 900000 + 100000)

    return prefix + year + month + day + randomNo
  }

  updateUser = (id, data) => {
    this.props.updateUser({ id: id, properties: data })
  }

  closePayment = () => {
    this.setState({
      showPayment: false
    })
  }

  openPayment = () => {
    if (this.state.selectedUser.selected) {
      this.setState({
        showPayment: true
      })
    } else {
      var alert = {
        showAlert: true,
        message: pleaseSelectText,
        type: 'warning',
        callback: () => {
          this.setState({ alert: _.clone(emptyAlert) })
        }
      }
      this.setState({ alert })
    }
  }

  applyDiscount = async () => {
    if (isBlank(this.state.discount.discountInput))
      return this.showAlert(invalidCodeText, 'warning')
    try {
      const response = await axios.get(
        config.serverURL +
          '/Discounts/isCodeValid?discountCode=' +
          this.state.discount.discountInput
      )

      if (response.data.result.isValid) {
        this.setState({
          discount: {
            ...this.state.discount,
            discountApplied: true,
            discountInstance: response.data.result.instance
          }
        })
      } else {
        this.showAlert(invalidCodeText, 'warning')
      }
    } catch (error) {
      this.showAlert(invalidCodeText, 'warning')
      console.log('payment - applyDiscount:', error.message)
    }
  }

  getPayAmount = () => {
    if (this.state.discount.discountApplied) {
      return (
        this.getTotal() *
        (1 - this.state.discount.discountInstance.percentage / 100)
      ).toFixed(2)
    } else {
      return this.getTotal()
    }
  }

  isPeak = () => {
    var peak
    this.props.bookingDates.forEach(dateObj => {
      if (
        this.isBetween(dateObj.startDate, dateObj.endDate, this.state.passDate)
      ) {
        var dayOfWeek = moment(this.state.passDate).day()
        var date = _.clone(dateObj['' + dayOfWeek])
        peak = date.peak
      }
    })
    return peak
  }

  getTotal = () => {
    let temp = this.state.tickets.reduce(
      (a, b) => +a + +b.singleTicketPrice * b.quantity,
      0
    )
    return temp / 10
  }

  getSearchItems = () => {
    var items = []
    if (this.state.search === '') items = this.props.recentUsers
    else items = this.search()

    if (!Array.isArray(items)) items = []

    return (
      <div className="searchWrapper searchBorder">
        {items.map((item, index) => {
          return (
            <div
              className={
                'searchRow smallText' +
                (index + 1 === items.length ? ' noBorder' : '')
              }
              key={index}
              onClick={() => this.selectUser(item)}>
              <div>{item.firstName + ' ' + item.lastName}</div>
              <div>{item.email}</div>
            </div>
          )
        })}
      </div>
    )
  }

  getInput = index => {
    return (
      <div className="guestAmountRow" key={index}>
        <div className="questAmountTitle">
          {guestGroupsText['guestGroup' + index + 'Text']}
        </div>
        <input
          type="number"
          disabled={this.state.paymentDone}
          className="questAmountInput"
          onChange={e => this.handleAmountChange('guestGroup' + index, e)}
          value={
            this.state['guestGroup' + index].length === 0
              ? ''
              : this.state['guestGroup' + index].length
          }
        />
      </div>
    )
  }

  getGroupItems = index => {
    return this.state['tickets'].map((item, i) => {
      return (
        <div className={'guestRow smallText' + ' guestOpened'} key={i}>
          <div className="guestTitle">{item.name}</div>
          <div>
            <div className="questInputHeader">{item.singleTicketPrice}</div>
            <div className="inputWrapper guestInput">
              <input
                type="text"
                value={item.quantity}
                disabled={this.props.requestLoading}
                onChange={e => this.handleGuestChange('quantity', index, i, e)}
                placeholder={0}
              />
            </div>
          </div>
        </div>
      )
    })
  }

  getPrice = () => {
    if (this.state.discount.discountApplied) {
      return (
        <div>
          <div>{totalText + ': ' + this.getTotal()}</div>
          <div>
            {discountedTotalText +
              ': ' +
              Math.round(this.getPayAmount() * 100) / 100}
          </div>
        </div>
      )
    } else {
      return <div>{totalText + ': ' + this.getTotal()}</div>
    }
  }

  getSlots = date => {
    var temp = []
    this.props.bookingDates.forEach(dateObj => {
      if (this.isBetween(dateObj.startDate, dateObj.endDate, date)) {
        var dayOfWeek = moment(date).day()
        temp = _.clone(dateObj['' + dayOfWeek].timeSlots)
      }
    })

    return temp
  }

  isBetween = (rangeStart, rangeEnd, date) => {
    var momentDate = moment(date).startOf('day')
    var momentStart = moment(rangeStart).startOf('day')

    if (rangeEnd === 'endless') {
      return (
        momentStart.isBefore(momentDate) ||
        momentStart.isSame(momentDate, 'day')
      )
    }
    var momentEnd = moment(rangeEnd).startOf('day')

    return (
      (momentStart.isBefore(momentDate) && momentDate.isBefore(momentEnd)) ||
      momentStart.isSame(momentDate, 'day') ||
      momentEnd.isSame(momentDate, 'day')
    )
  }

  clockAction = type => {
    const data = {
      type: type,
      userId: this.props.classObj.user.id
    }

    this.props.sendRequest(createAction, data)
  }

  getLatestClockIn = () => {
    var userActions = this.props.useractions.filter(action =>
      this.props.classObj.user
        ? action.userId === this.props.classObj.user.id
        : action.userId === this.props.classObj.onsiteUserId
    )

    var latestAction = null
    userActions.forEach(action => {
      if (
        latestAction === null ||
        moment(latestAction.date).isBefore(moment(action.date))
      ) {
        if (
          action.type === 'clockInBooking' ||
          action.type === 'clockOutBooking'
        ) {
          latestAction = action
        }
      }
    })

    if (latestAction === null) {
      return
    }

    return (
      <div className="amountInputRow">
        <div>
          {(latestAction.type === 'clockInBooking'
            ? clockinAtText
            : clockoutAtText) + ':'}
        </div>
        <div>{moment(latestAction.date).format('DD MMM YYYY HH:mm')}</div>
      </div>
    )
  }

  render() {
    return (
      <div
        className={
          'classWindow' + (this.state.shouldClose ? ' closeWindow' : '')
        }>
        <div className="playonlyView">
          <IosCloseCircleOutline
            onClick={() => this.animateClose()}
            className="closeIcon"
            fontSize="30px"
            color="#fff"
          />
          {this.props.classEditOn ? (
            <IosArrowRoundBack
              onClick={() => this.animateCloseOpen('checkbook')}
              className="backIcon"
              fontSize="45px"
              color="#fff"
            />
          ) : (
            void 0
          )}
          <div className="titleText">
            {this.props.classEditOn ? classText2 : classText}
          </div>
          {!this.props.classEditOn && (
            <div>
              {!this.state.selectedUser.selected ? (
                <div className="searchWindow">
                  <div className="subtitleText">{pleaseSelectUText}</div>
                  <div className="inputWrapper">
                    <input
                      type="text"
                      value={this.state.search}
                      disabled={this.props.requestLoading}
                      onChange={e => this.handleChange('search', e)}
                      placeholder={searchText}
                    />
                  </div>
                  <div className="searchWrapper addUserWrapper">
                    <div
                      className="searchRow addUserRow"
                      onClick={() => this.animateCloseOpen('register')}>
                      {addUserText}
                    </div>
                  </div>
                  {this.getSearchItems()}
                </div>
              ) : (
                <div className="searchWrapper selectedWrapper">
                  <div className="searchRow smallText selectedRow">
                    <div>{this.state.selectedUser.user.email + ''}</div>
                  </div>
                  {!this.state.paymentDone && (
                    <div
                      className="searchChange"
                      onClick={() => this.unselectUser()}>
                      {changeText}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
          <div className="subtitleText">{pleaseSelectGText}</div>
          <div className="guestsDetails">
            {[1].map(item => {
              return (
                <div key={item}>
                  {/* {this.getInput(item)} */}
                  <div className="searchWrapper fullWidth">
                    {this.getGroupItems(item)}
                  </div>
                </div>
              )
            })}
          </div>
          <div className="subtitleText">{noteText}</div>
          <div className="inputWrapper">
            <textarea
              type="text"
              cols="6"
              rows="6"
              value={this.state.note}
              onChange={e => {
                this.setState({ note: e.target.value })
              }}
            />
          </div>
          {this.state.image.length > 0 ? (
            <div>
              <div className="subtitleText">Image</div>
              <div className="inputWrapper">
                <img
                  src={this.state.image}
                  className="frontImage"
                  alt="User image"
                />
              </div>
            </div>
          ) : (
            <span />
          )}
          <div className="subtitleText">{datesText}</div>
          <div>
            <DatePicker
              disabled={this.state.paymentDone}
              className="dateInput"
              onChange={this.handleDateChange}
              value={this.state.passDate}
              clearIcon={null}
              calendarIcon={null}
            />

            <select
              className="guestTimeSelect"
              disabled={this.state.paymentDone}
              onChange={this.timeChange}
              value={this.state.selectedTime}>
              {this.getSlots(this.state.passDate).map((item, index) => {
                return <option key={index}>{item}</option>
              })}
            </select>
          </div>
          <div className="priceWrapper">
            {!this.props.classEditOn && (
              <div className="inputWrapper discountInput">
                <input
                  type="text"
                  value={this.state.discount.discountInput}
                  onChange={e => {
                    this.setState({
                      discount: {
                        ...this.state.discount,
                        discountInput: e.target.value
                      }
                    })
                  }}
                  placeholder={discountCodeText}
                />
                <div className="applyButton" onClick={this.applyDiscount}>
                  {applyText}
                </div>
              </div>
            )}
            <div>{this.getPrice()}</div>
          </div>
          {this.props.classEditOn && this.getLatestClockIn()}
          {this.props.classEditOn && (
            <div className="bookingButtons">
              <div
                className="buttonWrapper marginRight"
                onClick={() => this.clockAction('clockOutBooking')}>
                {clockoutText}
              </div>
              <div
                className="buttonWrapper"
                onClick={() => this.clockAction('clockInBooking')}>
                {clockinText}
              </div>
            </div>
          )}
          <div className="bookingButtons">
            {!this.state.paymentDone && !this.props.classEditOn && (
              <div
                className="buttonWrapper marginRight"
                onClick={() => this.openPayment()}>
                {payText}
              </div>
            )}
            {this.props.classEditOn && (
              <div className="buttonWrapper" onClick={() => this.delete()}>
                {deleteText}
              </div>
            )}
            <div
              className="buttonWrapper"
              onClick={() =>
                this.props.classEditOn ? this.change() : this.submit()
              }>
              {this.props.classEditOn ? changeText : submitText}
            </div>
          </div>
          <div className="marginBottom"></div>
        </div>
        {this.state.showPayment && (
          <Payment
            amount={this.getPayAmount() * 100}
            updateUser={this.updateUser}
            user={this.state.selectedUser.user}
            successCallback={this.submit}
            closePayment={this.closePayment}
          />
        )}
        {this.checkForAlert()}
      </div>
    )
  }
}

const mapStateToProps = ({ users, bookedit, bookings, useractions }) => ({
  users: users.users,
  useractions: useractions.data,
  recentUsers: users.recentUsers,
  bookingDates: bookings.bookingDates2,
  requestFailed: users.requestFailed,
  requestFailed2: bookedit.requestFailed,
  requestLoading: users.requestLoading,
  userForBooking: users.userForBooking,
  requestFinished: users.requestFinished,
  requestFinished2: bookedit.requestFinished,
  classObj: bookedit.classObj,
  classEditOn: bookedit.classEditOn
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      sendRequest,
      changeFinished,
      newUserRequired,
      fetchAll,
      newUserNotRequired,
      updateUser,
      changeFinished2,
      editFinished
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Class)
